
export const asLocalStorageItem = (pk, sk, item) => {
  if (!sk || !item || !pk) return null;
  return { pk, sk, item: { ...item } }
}
export const saveArrayToLocalStorage = (pk, arr) => {
  localStorage.setItem(pk, JSON.stringify(arr));
}
export const getArrayFromLocalStorage = (pk) => {
  const str = localStorage.getItem(pk);
  if (!str) return [];
  return JSON.parse(str);
}
export const getItemFromLocalStorage = (pk, sk) => {
  const items = getArrayFromLocalStorage(pk);
  if (!items) return null;
  const item = items.find((i) => { return i.sk === sk; })
  if (!item) return null;
  return item.item;
}
export default {
  putItem: (pk, sk, item, callback) => {
    try {
      const items = getArrayFromLocalStorage(pk);
      if (!items) {
        const newItems = [];
        const newItem = asLocalStorageItem(pk, sk, item);
        if (!newItem) {
          return callback(`Error:${JSON.stringify(newItem)}`)
        }
        newItems.push(newItem);
        saveArrayToLocalStorage(pk, newItems);
      } else {
        items.push(asLocalStorageItem(pk, sk, item));
        saveArrayToLocalStorage(pk, items);
      }
      return callback(null);
    } catch (e) {
      return callback(e);
    }
  },
  /**
   * @param {function(err,items)} callback
   */
  getItems: (pk, callback) => {
    const items = getArrayFromLocalStorage(pk);
    return callback(null, items);
  },
  getItem: (pk, sk, callback) => {
    const item = getItemFromLocalStorage(pk, sk);
    return callback(null, item);
  }
}


// WEBPACK FOOTER //
// ./src/util/mock/db.js